import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideEnvironmentInitializer,
} from '@angular/core';
import { AppIconRegistry } from './app-icon.registry';
import { AppIconCatalog } from './app-icon.types';

/**
 * Añade un catálogo al registro cuando se inicializa el entorno que lo provee.
 *
 * También se puede utilizar en los proveedores de una ruta lazy.
 */
export function provideAppIcons<const TCatalog extends AppIconCatalog>(
  catalog: TCatalog,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideEnvironmentInitializer(() => {
      inject(AppIconRegistry).addCatalog(catalog);
    }),
  ]);
}
